/**
 * @author       Pavlo Androshchuk
 * @copyright    Copyright (c) 2022, Zumper
 */

import { LIST_ITEM_CALL } from '@zcode-ui/web-zumper-integrations'
import { Origin } from '@zcode/nr-utils'
import { trackOptimizelyPhoneEvents } from '@zcode/nr/es/shared/thirdParty/optimizely/thunks'
import { hocCompose, withErrorBoundary } from '@zcode/react-utils'
import { routerConnect } from '@zcode/router-connect'
import type { RouteComponentProps } from '@zcode/router-utils'
import type { Listable } from '@zcode/state-type'
import type { SyntheticEvent } from 'react'
import { connect } from 'react-redux'
import type { Dispatch } from 'redux'
import { mixpanelCall } from '../../../../../../modules/mixpanel/thunks/mixpanelCall'
import { getPropertyTypeText } from '../../../../../../modules/router/selectors/index'
import { trackListItemEvent } from '../../../../../../modules/traktor/thunks/trackListItemEvent'
import { trackCallEvent } from '../../../../../../utils/trackCallEvent'
import { HeaderAndLocation } from './HeaderAndLocation'

const mapRouteToProps = (routeProps: RouteComponentProps) => {
  return {
    propertyTypeText: getPropertyTypeText(routeProps),
  }
}

interface OwnProps {
  entity: Listable
}

const mapDispatchToProps = (dispatch: Dispatch, ownProps: OwnProps) => {
  return {
    onPaidPhoneClick: (e: SyntheticEvent) => {
      e.stopPropagation()
      const { entity } = ownProps

      trackCallEvent(entity)
      dispatch(trackListItemEvent({ name: LIST_ITEM_CALL, entity }))
      dispatch(trackOptimizelyPhoneEvents({ entity, fromStickyBar: false }))
      dispatch(mixpanelCall({ entity, origin: Origin.LISTABLES }))
    },
  }
}

export const HeaderAndLocationContainer = hocCompose(
  routerConnect(mapRouteToProps, { forwardRouteProps: true }),
  connect(null, mapDispatchToProps),
  withErrorBoundary({ displayName: 'HeaderAndLocation' }),
  HeaderAndLocation
)
